
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grants",
      function () {
        return require("private-next-pages/grants/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grants"])
      });
    }
  